import React, { useEffect } from 'react';

// Sections
import Home from './components/Home';
import NavBar from './components/NavBar';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Experience from './components/Experience';

// Background
import Background from './components/Background';

// Cursor CSS
import './styles/cursor.css';

function App() {
  // Smooth scroll behavior
  useEffect(() => {
    const links = document.querySelectorAll('a[href^="#"]');
    const navbarHeight = 80; // Adjust if needed

    const handleClick = (e, hash) => {
      e.preventDefault();
      const element = document.querySelector(hash);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - navbarHeight,
          behavior: 'smooth'
        });
      }
    };

    links.forEach(link => {
      link.addEventListener('click', (e) => handleClick(e, link.getAttribute('href')));
    });

    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="font-sans text-white relative cursor-blue">
      {/* Fullscreen Animated Background */}
      <div className="fixed inset-0 -z-10">
        <Background />
      </div>

      {/* Navigation Bar */}
      <div className="relative z-20">
        <NavBar />
      </div>

      {/* Content Sections */}
      <div className="relative z-10">
        <section id="home">
          <Home />
        </section>

        <section id="about">
          <About />
        </section>


        <section id="skills">
          <Skills />
        </section>
        
        <section id="qualification">
          <Experience />
        </section>

        <section id="projects">
          <Projects />
        </section>

        <section id="contact">
          <Contact />
        </section>
      </div>
    </div>
  );
}

export default App;